<template>
    <div id="m-inbox" style="height: 100%">
        <v-overlay v-if="loading">
            <v-progress-circular indeterminate color="primary"/>
        </v-overlay>
        <v-alert type="error" width="20%" v-else-if="message" style="margin-top: 50px;margin-left: 50%;left: -10%;">
            {{ message }}
        </v-alert>
        <v-card v-else elevation="0">
            <v-card-actions class="ma-0 pa-2 mt-3">
                <v-text-field
                        style="margin-bottom: -30px"
                        v-model="searchKey"
                        label="Key Name"
                        placeholder="Enter value to find"
                        outlined
                        clearable
                        append-icon="mdi-magnify"
                        @click:append="searchAcount"
                        @keyup.enter="searchAcount"
                ></v-text-field>
            </v-card-actions>
            <v-card-actions class="ma-0 pa-0 ml-2">
                <v-tabs v-model="tab" class="no-transition">
                    <template v-for="item in tabs">
                        <v-tab :key="'tab-l-keys-list-view-'+ item.name" @click="onPressTab">{{item.name}}
                            <country-flag :country='item.flag' size='normal' class="pl-0" :rounded="true"/>
                            <v-badge v-if="hasEmptyValues(item.name)"
                                     color="red"
                                     bordered
                                     icon="mdi-exclamation-thick">
                            </v-badge>
                        </v-tab>
                    </template>
                </v-tabs>
            </v-card-actions>
            <v-card-actions>
                <v-card outlined width="100%" class="ma-0 pa-0">
                    <v-card-actions class="ma-0 pa-2">
                        <v-tabs-items class="mt-0" v-model="tab" style="width: 100%">
                            <template v-for="item in tabs">
                                <v-tab-item
                                        transition="fade-transition"
                                        reverse-transition="fade-transition"
                                        :key="'tab-l-keys-list-view-'+ item.name">
                                    <l-keys-list-view
                                            :language="item"
                                            ref="l-keys-list-view">
                                    </l-keys-list-view>
                                </v-tab-item>
                            </template>
                        </v-tabs-items>
                    </v-card-actions>
                </v-card>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>

import LKeysListView from "@/modules/mlocalization/views/l-keys-list-view";
import LocalizationStore from "@/modules/mlocalization/database/LocalizationStore";
import {LocalizationStoreUtils} from "@/modules/mlocalization/database/LocalizationStoreUtils";

export default {
    components: {LKeysListView},
    data: () => ({
        searchKey: null,
        loading: true,
        message: "",
        tab: null,
        reloading:false,
    }),
    methods: {
        onPressTab(){
            let self = this
            setTimeout(function() {
                self.searchAcount()
            }, 500)
        },
        searchAcount() {
            let refs = this.$refs['l-keys-list-view']
            for (let ref in refs){
                refs[ref].setSearchKey(this.searchKey)
            }
        },
        hasEmptyValues(language){
            let localizations = LocalizationStoreUtils.getLocalizations()
            for (let k in localizations.keys){
                if (localizations.keys[k][language] == undefined){
                    return true
                }
            }
            return false
        },
    },
    computed:{
        tabs(){
            let localizations = LocalizationStoreUtils.getLocalizations()
            if (localizations == undefined){
                return []
            }
            return localizations.tabs
        },
    },
    beforeMount() {
        this.loading = true
        this.$store.registerModule("localization-store", LocalizationStore);
        this.$store.dispatch("localization-store/init").then(() => {
            console.log("Loaded successfully. localization-store");
        }).catch(() => {
            this.message = "Load failed!";
        }).finally(() => {
            this.loading = false;
        });
    },
    destroyed() {
        this.$store.unregisterModule("localization-store");
        console.log("destroy root view localization");
    }
}
</script>

<style scoped>
</style>